import React, { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import bg from "../images/Bg.png";
import Tick_Square from "../images/Tick Square.svg";
import { server_API } from "../config";
import file_upload from "../images/Action Icon Filled.svg";
import success from "../images/success.png";
import axiosInstance from "../axiosInstance";
import { toast, ToastContainer } from "react-toastify";
const DocUpload = () => {
  const params = useParams();
  const cid = params.cid;
  const aid = params.aid;
  const fileInputRef = useRef(null);
  const [logo, setLogo] = useState("");
  const [tab, setTab] = useState(0);
  const [jobid, setJobid] = useState("");
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [pnum, setPnum] = useState("");
  const [job, setJobdetails] = useState({});
  const [allDocuments, setAllDocuments] = useState([]);
  const [file, setFile] = useState(null);
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [pin, setPin] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [companyCountryCode, setCompanyCountryCode] = useState("");
  const [applicantCountryCode, setApplicantCountryCode] = useState("");
  const [pinLoading, setPinLoading] = useState(false);
  const pinRef = useRef(pin);
  pinRef.current = pin;
  const isGB = companyCountryCode === "GB";
  const isAddressValid = isGB
    ? (address1.trim().length > 0 && city.trim().length > 0 && pin.trim().length > 0 && /^[A-Za-z0-9 ]+$/.test(pin))
    : (address1.trim().length > 0 && pin.trim().length === 6);

  function flattenDocuments(records) {
    const all = [];
    if (!Array.isArray(records)) return all;
    records.forEach((record) => {
      if (Array.isArray(record.documentinfo)) {
        record.documentinfo.forEach((doc) => {
          all.push({ ...doc, parentUuid: record.uuid });
        });
      }
    });

    const seen = new Map();
    all.forEach((doc) => {
      const name = doc.document_name;
      if (!seen.has(name)) {
        seen.set(name, doc);
      } else {
        const existing = seen.get(name);
        if (doc.status === "Pending" && existing.status !== "Pending") {
          seen.set(name, doc);
        }
      }
    });
    return Array.from(seen.values());
  }

  function getNextPendingTab(docs, startIdx) {
    for (let idx = startIdx; idx < docs.length; idx++) {
      if (docs[idx].status === "Pending") {
        return idx + 1;
      }
    }
    return null;
  }

  const fetchDocuments = useCallback(async () => {
    try {
      const res = await axiosInstance.get(`/v2/document/get/applicant/${aid}/${cid}`);
      const docs = flattenDocuments(res.data);
      setAllDocuments(docs);
      return docs;
    } catch (error) {
      console.error("fetchDocuments error:", error);
      return [];
    }
  }, [aid, cid]);

  useEffect(() => {
    axiosInstance
      .get(`/v2/applicant/get/${aid}/${cid}`)
      .then((response) => {
        setJobid(response.data.jobid);
        setName(response.data.name);
        setEmail(response.data.email);
        setPnum(response.data.phone);
        if (response.data.gender) setGender(response.data.gender);
        if (response.data.countrycode) setApplicantCountryCode(response.data.countrycode);
        if (response.data.address) {
          const address = response.data.address.split(",");
          setAddress1((address[0] || "").trim());
          setAddress2((address[1] || "").trim());
          setPin((address[2] || "").trim());
          setCity((address[3] || "").trim());
          setState((address[4] || "").trim());
          setCountry((address[5] || "").trim());
        }
      })
      .catch((error) => {
        console.error(error);
      });
    if (cid) {
      axiosInstance
        .get(`/v2/company/get/${cid}`)
        .then((res) => {
          if (res.data.company_countries && res.data.company_countries.length > 0) {
            setCompanyCountryCode(res.data.company_countries[0]);
          }
        })
        .catch((err) => {
          console.error("Error fetching company details:", err);
        });
    }
    axios
      .get(`${server_API}/v2/company/geturl/${cid}`)
      .then((response) => {
        setLogo(response.data.url);
      })
      .catch((error) => {
        console.log(error);
      });
    fetchDocuments();
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      toast.error("File size should be less than 2MB");
      event.target.value = null;
      return;
    }
    setFile(file);
  };

  function handleDefault() {
    setFile(null);
  }

  const sendMail = () => {
    axios
      .post(`${server_API}/v2/document/notification/${aid}/${cid}`)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.size > 2 * 1024 * 1024) {
      toast.error("File size should be less than 2MB");
      return;
    }
    setFile(droppedFile);
  };

  const fetchPincodeDetails = useCallback(async (pincode) => {
    const trimmed = String(pincode).trim();
    if (trimmed.length !== 6 || !/^\d{6}$/.test(trimmed)) return;
    setPinLoading(true);
    try {
      const res = await axios.get(
        `https://api.postalpincode.in/pincode/${trimmed}`
      );
      const data = res.data?.[0];
      if (data?.Status === "Success" && data?.PostOffice?.length > 0 && pinRef.current === trimmed) {
        const first = data.PostOffice[0];
        setCity(first.District || "");
        setState(first.State || "");
        setCountry(first.Country || "India");
      }
    } catch (err) {
      console.error("Pincode lookup error:", err);
    } finally {
      if (pinRef.current === trimmed) setPinLoading(false);
    }
  }, []);

  // Auto-fetch when user enters 6-digit pincode (no need to tab out)
  useEffect(() => {
    if (isGB) return;
    const trimmed = String(pin).trim();
    if (trimmed.length === 6 && /^\d{6}$/.test(trimmed)) {
      fetchPincodeDetails(trimmed);
    }
  }, [pin, fetchPincodeDetails, isGB]);

  const uploadDoc = async (docId, parentUuid, isLast) => {
    const formData = new FormData();
    formData.append("uploadedby", "Candidate");
    formData.append("uploadeddate", new Date());
    formData.append("uuid", parentUuid);
    formData.append("documentid", docId);
    formData.append("companyid", cid);
    formData.append("applicantid", aid);
    formData.append("file", file);
    formData.append("status", "Under Review");
    try {
      await axios.patch(`${server_API}/v2/document/addeddocument`, formData);
      setFile(null);
      const freshDocs = await fetchDocuments();
      const nextPending = getNextPendingTab(freshDocs, 0);
      if (nextPending) {
        setTab(nextPending);
      } else {
        if (isLast) sendMail();
        setTab(99);
      }
    } catch (err) {
      console.error("uploadDoc error:", err);
      toast.error("Failed to upload document. Please try again.");
    }
  };

  const patchUser = async () => {
    try {
      const finalCity = isGB ? city.toUpperCase() : city;
      await axios.patch(`${server_API}/v2/applicant/update`, {
        uuid: aid,
        address: `${address1}, ${address2}, ${pin}, ${finalCity}, ${state}, ${country}`,
        gender: gender,
        companyid: cid,
      });
      const freshDocs = await fetchDocuments();
      const nextPending = getNextPendingTab(freshDocs, 0);
      if (nextPending) {
        setTab(nextPending);
      } else {
        setTab(99);
      }
    } catch (err) {
      console.error("patchUser error:", err);
      toast.error("Failed to save details. Please try again.");
    }
  };

  useEffect(() => {
    if (jobid) {
      axiosInstance
        .get(`/v2/job/get/${jobid}/${cid}`)
        .then((response) => {
          console.log(response);
          setJobdetails(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [jobid]);

  // useEffect(()=>{
  //   if (job?.assignrecruiter?.length >0){
  //      axios.get(`${server_API}/v2/user/getuser/${job?.assignrecruiter}`)
  //       .then((response) => {
  //         setRecuiterEmail(response?.data?.success?.email);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }

  // },[job])

  return (
    <div>
      <div className="bg-cover bgGradient py-10 min-h-screen flex flex-col  ">
        <img src={logo} className="mx-auto h-20 my-10"></img>
        <div className="mx-[150px] bg-white rounded-lg shadow-xl">
          {tab < 99 ? (
            <div>
              <div>
                <div className="border-b">
                  <div className="px-4 py-4">
                    <p className="text-xl font-semibold">{job?.profilename}</p>
                    <p className="mt-2 text-sm font-semibold">
                      {job?.jobtype} |
                      {job.workstyle && <span> {job?.workstyle} | </span>}{" "}
                      {job["location:"]}
                    </p>
                  </div>
                </div>
                <div className="py-5">
                  <div className="flex items-center justify-evenly">
                    <div className="flex items-center space-x-2">
                      <p className="text-white bg-gray-700 px-2 rounded-full">
                        1
                      </p>
                      <p>Details</p>
                    </div>
                    {allDocuments.map((p, i) => {
                      return (
                        <div key={p.documentid || i}>
                          <div className="flex items-center space-x-2">
                            <p className="text-white bg-gray-700 px-2 rounded-full">
                              {i + 2}
                            </p>
                            <p>{p.document_name}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="rounded-full mx-4 p-[0.01rem] relative bg-slate-300 my-4 h-[0.5rem]">
                    <div
                      style={{
                        width: `${((tab + 1) /
                          (allDocuments.length + 1)) *
                          100
                          }%`,
                      }}
                      className={`absolute  h-[0.5rem] rounded-full bg-[#0DCD94]`}
                    ></div>
                  </div>
                </div>
              </div>
              {tab == 0 && (
                <div className="p-4">
                  <p className="text-sm text-gray-500 mb-4">
                    Fields marked with <span className="text-red-500">*</span> are compulsory
                  </p>
                  <div className="md:flex w-full md:space-y-0  space-y-2 md:space-x-3">
                    <div className="md:w-1/2">
                      <p className="font-semibold  bg-opacity-60 opacity-60">
                        {" "}
                        Name <span className="text-red-500">*</span>
                      </p>
                      <input
                        className={`w-full bg-opacity-60 opacity-60 outline-none border px-2 py-1 rounded-lg mt-2 `}
                        type="text"
                        value={name}
                        readOnly
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      ></input>
                    </div>
                    <div className="md:w-1/2">
                      <p className="font-semibold">
                        Gender
                        <span className="text-red-500">*</span>
                      </p>
                      <div className=" flex items-start space-x-3 mt-2 justify-start">
                        <div className="w-full flex space-x-3 ">
                          <div className="flex space-x-2">
                            <input
                              className=" outline-none border px-2 py-1 rounded-lg "
                              type="radio"
                              checked={gender === "M"}
                              onClick={() => setGender("M")}
                            ></input>
                            <p>Male</p>
                          </div>
                          <div className="flex space-x-2">
                            <input
                              className=" outline-none border px-2 py-1 rounded-lg "
                              type="radio"
                              checked={gender === "F"}
                              onClick={() => setGender("F")}
                            ></input>
                            <p>Female</p>
                          </div>
                          <div className="flex space-x-2">
                            <input
                              className=" outline-none border px-2 py-1 rounded-lg "
                              type="radio"
                              checked={gender === "O"}
                              onClick={() => setGender("O")}
                            ></input>
                            <p>Others</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:flex w-full  bg-opacity-60 opacity-60 mt-5 md:space-y-0  space-y-2 md:space-x-3">
                    <div className="md:w-1/2">
                      <p className="font-semibold">
                        {" "}
                        Email <span className="text-red-500">*</span>
                      </p>
                      <input
                        className={`w-full outline-none border px-2 py-1 rounded-lg mt-2 `}
                        type="text"
                        readOnly
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      ></input>
                    </div>
                    <div className="md:w-1/2">
                      <p className="font-semibold">
                        Number
                        <span className="text-red-500">*</span>
                      </p>
                      <div className=" flex items-start space-x-3 mt-2 justify-start">
                        <div className="w-full">
                          <input
                            value={pnum}
                            readOnly
                            onChange={(e) => {
                              setPnum(e.target.value);
                            }}
                            className="w-full outline-none border px-2 py-1 rounded-lg "
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full mt-4 items-end space-x-3 doc-upload-address">
                    <div className="w-1/2">
                      <p className="font-semibold">
                        {isGB ? "Address Line 1" : "Address Line 1 (Street, Area, Building)"} <span className="text-red-500">*</span>
                      </p>
                      <input
                        value={address1}
                        onChange={(e) => setAddress1(e.target.value)}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                        placeholder={isGB ? "Address Line 1" : "e.g. 123 Main Street, Koramangala"}
                        required
                      />
                    </div>
                    <div className="w-1/2">
                      <p className="font-semibold">
                        Address Line 2 <span className="text-gray-400 text-sm font-normal">(Optional)</span>
                      </p>
                      <input
                        value={address2}
                        onChange={(e) => setAddress2(e.target.value)}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                        placeholder={isGB ? "Address Line 2" : "e.g. Landmark, Floor"}
                      />
                    </div>
                  </div>
                  <div className="flex w-full space-x-3 mt-3 doc-upload-address">
                    <div className="w-1/4">
                      <p className="font-semibold">
                        {isGB ? "Postcode" : "Pincode"} <span className="text-red-500">*</span>
                      </p>
                      <input
                        placeholder={isGB ? "e.g. SW1A 1AA" : "e.g. 560001"}
                        value={pin}
                        onChange={(e) => {
                          const val = e.target.value;
                          setPin(isGB ? val : val.replace(/\D/g, ""));
                        }}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                        maxLength={isGB ? 10 : 6}
                        inputMode={isGB ? "text" : "numeric"}
                      />
                      {!isGB && pinLoading && (
                        <span className="text-xs text-gray-500 mt-1 block">
                          Looking up...
                        </span>
                      )}
                    </div>
                    <div className="w-1/4">
                      <p className="font-semibold">{isGB ? "Town or City" : "City"}{isGB && <span className="text-red-500"> *</span>}</p>
                      <input
                        placeholder={isGB ? "Town or City" : "Auto-fills from pincode"}
                        value={city}
                        onChange={(e) => setCity(isGB ? e.target.value.toUpperCase() : e.target.value)}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                      />
                    </div>
                    <div className="w-1/4">
                      <p className="font-semibold">{isGB ? "Locality Name (Optional)" : "State"}</p>
                      <input
                        placeholder={isGB ? "Locality Name" : "Auto-fills from pincode"}
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                      />
                    </div>
                    <div className="w-1/4">
                      <p className="font-semibold">Country</p>
                      <input
                        placeholder={isGB ? "Country" : ""}
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        className="w-full outline-none border px-2 py-1 rounded-lg mt-2"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-5 pt-5 border-t">
                    <button className="text-[#148EFF] border-[#148EFF] px-4 py-2 rounded-lg border">
                      Reset
                    </button>
                    <button
                      className={
                        gender.length > 0 && isAddressValid
                          ? "text-white bg-[#148EFF] px-4 py-2 rounded-lg border"
                          : "bg-gray-400 text-white px-4 py-2 rounded-lg border"
                      }
                      disabled={!(gender.length > 0 && isAddressValid)}
                      onClick={() => {
                        patchUser();
                      }}
                    >
                      Save & Next
                    </button>
                  </div>
                </div>
              )}
              {allDocuments.map((p, i) => {
                const isDisabled = p.status && p.status !== "Pending";
                const isActiveTab = tab === i + 1;

                return (
                  <div key={p.documentid || i} className={isDisabled ? "opacity-50 pointer-events-none" : ""}>
                    {isActiveTab && (
                      <div>
                        <p className="pl-4">
                          Upload your {p.document_name}{" "}
                          {isDisabled && (
                            <span className="text-sm text-gray-500">
                              ({p.status.charAt(0).toUpperCase() + p.status.slice(1)})
                            </span>
                          )}
                        </p>

                        <div className="bg-white">
                          <div className="card-body p-6 flex flex-col gap-2"
                            onDrop={isDisabled ? undefined : handleDrop}
                            onDragOver={isDisabled ? undefined : handleDragOver}
                            onDragEnter={isDisabled ? undefined : handleDragEnter}
                            aria-disabled={isDisabled}
                          >
                            {file != null ? (
                              <>
                                <div className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-8 gap-5">
                                  <div className="border-2 rounded-md border-gray-300 flex flex-col">
                                    <span className="flex justify-end p-1"></span>
                                    <div className="flex gap-2 items-center px-6 pb-4">
                                      <div>
                                        <img src={file_upload} alt="Uploaded file" />
                                      </div>
                                      <span>{file?.name}</span>
                                    </div>
                                  </div>
                                  <span className="text-xl font-medium" style={{ color: "#0DCD94" }}>
                                    File Uploaded Successfully
                                  </span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div
                                  className="w-full border-dashed border-2 border-gray-300 rounded-md flex flex-col items-center py-8 cursor-pointer"
                                  onClick={() => {
                                    if (!isDisabled) fileInputRef.current.click();
                                  }}
                                >
                                  <div className="p-6">
                                    <img src={Tick_Square} className="" alt="Tick" />
                                  </div>
                                  <span className="text-xl font-medium" style={{ color: "#0DCD94" }}>
                                    Select a file to upload
                                  </span>
                                  <span className="text-sm text-gray-500 pb-2">
                                    drag & drop it here
                                  </span>
                                  <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept=".pdf, .jpg, .jpeg, .png, .doc, .docx"
                                    className="hidden"
                                    onChange={isDisabled ? undefined : handleFileUpload}
                                  />
                                </div>
                              </>
                            )}
                          </div>

                          <div className="border w-full"></div>
                          <div className="card-footer pb-6 pl-6 pr-6 pt-3 relative">
                            <div className={file != null ? "flex justify-between" : "flex justify-end"}>
                              {file != null && (
                                <button
                                  onClick={() => {
                                    if (!isDisabled) setFile(null);
                                  }}
                                  className="border-[#148EFF] border bg-white rounded-[4px] text-[#148EFF] py-2 px-3"
                                  disabled={isDisabled}
                                >
                                  Replace
                                </button>
                              )}
                              <button
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-[4px]"
                                disabled={!file || isDisabled}
                                onClick={() => {
                                  if (isDisabled) return;
                                  const isLast = tab === allDocuments.length;
                                  uploadDoc(p.documentid, p.parentUuid, isLast);
                                }}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}

            </div>
          ) : (
            <div className="bg-white p-8 rounded-xl">
              <img src={success} className="h-52 mx-auto "></img>
              <p className="text-[#0DCD94] text-2xl font-semibold mt-5 text-center">
                All required documents have been successfully uploaded.
              </p>
              <p className=" text-xl font-semibold mt-5 text-center">
                Our team will review the documents and contact you shortly
                regarding the next steps. For queries, please contact us at{" "}
                <span className="text-[#148EFF]">{"interviews@northstarz.ai"}</span>.
              </p>
            </div>
          )}
        </div>
      </div>
      <ToastContainer></ToastContainer>
    </div>
  );
};

export default DocUpload;
